import React from 'react';
import { CircleCheck, ArrowRight } from 'lucide-react';
import { whatHappensNextYes, images } from '../../data/mock';

const WhatHappensSection = () => {
  return (
    <section id="how-it-works" className="bg-bg-secondary">
      <div className="grid lg:grid-cols-2 min-h-[700px]">
        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 lg:px-12 xl:px-20 py-16 lg:py-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-text-primary leading-tight mb-4">
            {whatHappensNextYes.title}
          </h2>
          <p className="text-lg text-text-secondary mb-12">{whatHappensNextYes.intro}</p>

          {/* Steps */}
          <div className="space-y-6 mb-12">
            {whatHappensNextYes.steps.map((step, index) => (
              <div key={index} className="flex gap-4">
                <div className="w-10 h-10 bg-accent-orange text-white flex items-center justify-center flex-shrink-0 text-lg font-medium">
                  {index + 1}
                </div>
                <p className="text-text-primary pt-2">{step}</p>
              </div>
            ))}
          </div>

          {/* Pricing Summary */}
          <div className="space-y-4 mb-8">
            <div className="flex items-start gap-3">
              <CircleCheck className="w-5 h-5 text-accent-green flex-shrink-0 mt-0.5" />
              <p className="text-text-primary">
                <span className="font-medium">{whatHappensNextYes.pricing.hosting}</span>
                <br />
                <span className="text-text-secondary text-sm">{whatHappensNextYes.pricing.includes}</span>
              </p>
            </div>
            <div className="flex items-start gap-3">
              <CircleCheck className="w-5 h-5 text-accent-green flex-shrink-0 mt-0.5" />
              <p className="text-text-primary">{whatHappensNextYes.pricing.clients}</p>
            </div>
          </div>

          <p className="text-2xl font-medium text-accent-orange">{whatHappensNextYes.conclusion}</p>
        </div>

        {/* Image */}
        <div className="relative min-h-[400px] lg:min-h-full">
          <img
            src={images.salonInterior}
            alt="Salon interior"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default WhatHappensSection;
